<script>
  import ConfigSettings from "../components/configSettings.svelte";
  import PageContainer from "../components/shared/PageContainer.svelte";
</script>

<PageContainer>
  <div class="grid grid-cols-1 gap-3 w-full">
    <div class="uimodule">
      <ConfigSettings />
    </div>
  </div>
</PageContainer>
